import { IProduct } from '@/retail/contexts/product/domain/IProduct'
import { IProductRepository } from '@/retail/contexts/product/domain/IProductRepository'

export class GetProductBySku {
  constructor(private readonly productRepository: IProductRepository) {}

  public async execute(sku: string): Promise<IProduct> {
    return this.productRepository.getProductBySku(sku)
  }
}
